import { render } from "./AgentsTransactions.vue?vue&type=template&id=0d355253"
import script from "./AgentsTransactions.vue?vue&type=script&lang=js"
export * from "./AgentsTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__